export interface AppErrorOptions {
  status?: number;
  showInInterceptor?: boolean;
  duration?: number;
  isInterruptible?: boolean;
}

export class AppError extends Error {
  showInInterceptor = true;
  status?: number;
  duration?: number;

  constructor(
    message: string,
    options?: {
      status?: number;
      showInInterceptor?: boolean;
      duration?: number;
    }
  ) {
    super(message);
    this.name = 'AppError';

    if (options) {
      this.status = options.status;
      this.showInInterceptor = options.showInInterceptor !== false;
      this.duration = options.duration || 10000; // Default 10 seconds
    }
  }
}
